module.exports = __webpack_public_path__ + "img/background02.5ed36838.jpg";